import { TransactionType } from 'modules/cost/api/types'
import { useTranslation } from 'react-i18next'

import { Chip } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'

interface TransactionTypeChipProps {
  transactionType: TransactionType | undefined
}

const TransactionTypeChip = ({ transactionType }: TransactionTypeChipProps) => {
  const { t } = useTranslation('cost')
  const theme = useTheme()

  if (!transactionType) return null

  const styleMap: Record<string, object> = {
    product_issue: {
      backgroundColor: alpha(theme.palette.info.light, 0.08),
      color: theme.palette.info.main,
      border: '1px solid ' + theme.palette.info.main,
    },
    use_product: {
      backgroundColor: alpha(theme.palette.warning.main, 0.08),
      color: theme.palette.warning.main,
      border: '1px solid ' + theme.palette.warning.main,
    },
    transfer_in: {
      backgroundColor: alpha(theme.palette.primary.light, 0.08),
      color: theme.palette.primary.main,
      border: '1px solid ' + theme.palette.primary.main,
    },
    transfer_out: {
      backgroundColor: alpha(theme.palette.error.light, 0.08),
      color: theme.palette.error.main,
      border: '1px solid ' + theme.palette.error.main,
    },
    note: {
      backgroundColor: alpha(theme.palette.grey[200], 0.08),
      color: theme.palette.common.black,
      border: '1px solid ' + theme.palette.grey[400],
    },
  }

  const sx = styleMap[transactionType] ?? {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.common.black,
    border: '1px solid ' + theme.palette.common.black,
  }

  return (
    <Chip
      label={t(transactionType)}
      size="small"
      sx={{ px: 1, borderRadius: 1, fontSize: 12, fontWeight: 600, ...sx }}
    />
  )
}

export default TransactionTypeChip
